<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";

import FeedbackBlock from "@js/components/Sections/Feedbacks/Components/FeedbackBlock.vue";
import {Link} from "@inertiajs/vue3";
import IconComment from "@js/components/Icons/IconComment.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "Feedbacks",
    components: {
        IconAngleLeft,
        OnlyDesktop, OnlyMobile, IconComment, Link, FeedbackBlock, Swiper, SwiperSlide
    },
    data() {
        return {
            slider_breakpoints: {
                640: {slidesPerView: 1.2, spaceBetween: 10},
                768: {slidesPerView: 1.5, spaceBetween: 20},
                1024: {slidesPerView: 2.5, spaceBetween: 20}
            },
            text_feedbacks: [
                {
                    name: 'Михаил Тяжельников',
                    text: 'Решил сделать подъездную дорожку к даче из ЖБИ-плит. Связался с Дмитрием, он посоветовал, какие плиты лучше подходят к неровному рельефу и сезонным перепадам температур. Договорились о доставке, всё приехало в срок. Мастера быстро уложили плиты, и теперь я могу спокойно проезжать даже на тяжёлом авто, не боясь просадок.',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=z3w42jutteyrf00zjnmenvc4j0&utm_source=review',
                    date_formatted: '06 Февраля 2025',
                    date: '2025-02-06',
                },
                {
                    name: 'Григорий Манушакян',
                    text: 'Мы занимаемся дорожным строительством, и нам нужны были надежные дорожные плиты, соответствующие ГОСТ. Заказывали здесь крупную партию, и компания полностью оправдала ожидания. Понравился профессиональный подход – с нами работал персональный менеджер, который помог с расчетами и подбором. Все документы были оформлены оперативно, доставка точно в срок, без задержек. Качество плит – выше всяких похвал: прочный бетон, правильная геометрия, никаких дефектов. Дорогу уложили, плиты уже прошли испытание временем и нагрузками. Теперь сотрудничаем только с этим поставщиком!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=edxdkwxyuthdcwy2cc1e0tgbyg&utm_source=review',
                    date_formatted: '30 Января 2025',
                    date: '2025-01-30',
                },
                {
                    name: 'Kirill Bespalov',
                    text: 'Заказывал дорожные плиты для обустройства временной дороги на строительном объекте. Перед покупкой тщательно изучил предложения, сравнил цены и выбрал эту компанию по отзывам и рекомендациям. И не ошибся! Менеджер очень оперативно ответил на все вопросы, помог подобрать плиты, исходя из нагрузки и условий эксплуатации. Доставка была организована на следующий день, причем водитель прибыл точно в оговоренное время, без задержек. Плиты разгрузили аккуратно, при проверке оказалось, что каждая полностью соответствует заявленным характеристикам: ровная геометрия, никаких трещин или сколов, бетон плотный, армирование качественное. Прошло уже несколько месяцев, техника активно использует эту дорогу, плиты не проседают, не трескаются, выдерживают любые нагрузки. Однозначно рекомендую!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=z6c75trrwdnp5r2mrdupmt1fxr&utm_source=review',
                    date_formatted: '02 Февраля 2025',
                    date: '2025-02-02',
                },
                {
                    name: 'Михаил Я.',
                    text: 'Мы долго искали поставщика, у которого можно купить дорожные плиты без переплат. Здесь цены оказались адекватными, а качество – на высшем уровне. Плиты привезли без задержек, документы предоставили сразу. Проверили каждую – все соответствуют ГОСТ, без дефектов. Уже использовали их на объекте, выдерживают тяжелую технику без малейших проблем. Теперь работаем только с этой компанией. Спасибо за честность и профессионализм!',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=dfm626a5pnzhb17x21v0kj1w3c&utm_source=review',
                    date_formatted: '31 Января 2025',
                    date: '2025-01-31',
                },
            ],
            swiper: null,
        };
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
        insertSchemaMarkup() {
            if (checkDocument()) {
                const scriptId = "schema-reviews-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": this.text_feedbacks.map((feedback, index) => ({
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": feedback.name
                        },
                        "datePublished": feedback.date,
                        "reviewBody": feedback.text,
                        "url": feedback.link,
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": 5,
                            "bestRating": 5
                        }
                    }))
                })

                document.head.appendChild(script);
            }
        },
        removeSchemaMarkup() {
            if (checkDocument()) {
                const script = document.getElementById("schema-reviews-jsonld")
                if (script) {
                    script.remove()
                }
            }
        }
    },
    mounted() {
        this.insertSchemaMarkup()
    },
    beforeUnmount() {
        this.removeSchemaMarkup()
    },
};
</script>

<template>
    <div>
        <div class="container mb-5">
            <h2 class="text-2xl font-semibold text-left">
                Отзывы компании
            </h2>
        </div>
        <div class="md:container ms-5">
            <Swiper :slides-per-view="1.2"
                    :space-between="10"
                    @swiper="setSwiper"
                    :loop="true"
                    :breakpoints="slider_breakpoints"
                    class="mb-8 w-full">
                <SwiperSlide v-for="(feedback, index) in text_feedbacks" :key="index">
                    <FeedbackBlock :link="feedback.link" :text="feedback.text" :name="feedback.name"
                                   :date="feedback.date_formatted" class="min-h-[240px] md:min-h-[255px]"/>
                </SwiperSlide>
            </Swiper>
            <div class="flex items-end justify-between max-md:me-5 mt-5">
                <div class="flex gap-3 max-md:hidden">
                    <button v-if="swiper" @click.prevent="slidePrev" aria-label="Назад"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5"/>
                    </button>
                    <button v-if="swiper" @click.prevent="slideNext" aria-label="Вперед"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5 rotate-180"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
